import React from 'react';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import Experience from './components/Experience/Experience';
import Projects from './components/Projects/Projects';
import HomeLab from './components/HomeLab/HomeLab';
import TelegramBots from './components/TelegramBots/TelegramBots';
import AIWorkflow from './components/AIWorkflow/AIWorkflow';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';

function App() {
    return (
        <div className="App overflow-x-hidden">
            <Navbar />
            <Hero />
            <About />
            <Experience />
            <Projects />
            <HomeLab />
            <TelegramBots />
            <AIWorkflow />
            <Contact />
            <Footer />
        </div>
    );
}

export default App;
